import $ from 'jquery';

const validateLoginForm = (form) => !$(form).find('input[name="USERID"], input[name="PWD"]')
	.toArray()
	.some((input) => input.value === '');

export default validateLoginForm;



// WEBPACK FOOTER //
// ./src/js/index/validateLoginForm.js